import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import ReactIframeResizer from "../../common/iFrameResizerComponent";
import { getURLPath } from '../../../helpers/Tools';
import { logUI } from '../../../api/andyliticsApi';
import VideoVisitComplete from './VideoVisitComplete';

const SURVEY_CANCELLED = "surveycancelled";
const SURVEY_COMPLETED = "surveycompleted";

/**
 * Video Visit Survey.
 * 
 */

class VideoVisitSurvey extends React.Component {
    constructor(props) {
        super(props);  
        const { serverData, isFromNonLogin, shareLinkSurveyId } = props;
        this.serverData = serverData;
        this.state = { isSurveyCompleted: false, showNonLoginVideoVisitComplete: false };
        this.processWindowMessage = this.processWindowMessage.bind(this);
        if (isFromNonLogin && shareLinkSurveyId) {
            this.surveyId = shareLinkSurveyId;
        } else if (this.props.isSDCVisit) {
            this.surveyId = this.serverData && this.serverData.surveyIdForSDCV2 ? this.serverData.surveyIdForSDCV2 : null;           
        } else {
            this.surveyId = this.serverData && this.serverData.surveyIdForAmbulatoryV2 ? this.serverData.surveyIdForAmbulatoryV2 : null;           
        }
    }

    componentDidMount() {
        this._isMounted = true;
        window.formChanged = false;
        window.addEventListener("message", this.processWindowMessage);
        const { surveyUrl } = this.props;
        let andyliticsJson = {
            surveyUrl
        };
        logUI("MBHWeb.UI.VideoVisitSurvey.ComponentDidMount", new Date(), getURLPath(), andyliticsJson);
    }

    componentWillUnmount() {
        this._isMounted = false;
        window.formChanged = false;
        window.removeEventListener("message", this.processWindowMessage);
    }

    processWindowMessage(messageEvent) {
        const { token, submitSurvey, isSDCVisit, twilioUserName, isFromNonLogin } = this.props;
        let surveyLogValue = {
            SurveryId: this.surveyId,
            VisitType: isSDCVisit ? "SDC" : "Ambulatory",
            twilioUserName: twilioUserName,
            shareLink: isFromNonLogin ? true : false
        };
        if (messageEvent.data && messageEvent.data === SURVEY_CANCELLED) {
            logUI("MBHWeb.UI.VideoVisitSurvey.Cancelled", new Date(), getURLPath(), surveyLogValue);  
            if (isFromNonLogin) {
                this.setState({showNonLoginVideoVisitComplete: true});
            } else {
                this.props.history.push("/dashboard");
            }       
            
        } else if (messageEvent.data && messageEvent.data === SURVEY_COMPLETED) {
            logUI("MBHWeb.UI.VideoVisitSurvey.Completed", new Date(), getURLPath(), surveyLogValue);
            this.setState({ isSurveyCompleted: true });
            if (submitSurvey && !isFromNonLogin) {
                submitSurvey();       
            } else {
                this.setState({showNonLoginVideoVisitComplete: true});
            }    
            //this.props.history.push({ pathname: "/", state: { isComplete: true } });
        }
    }

    render() {

        //debugger;
        const { reloadKey, isEmployee, csnId, userDetails, surveyUrl, twilioUserName, isFromNonLogin, externalEventId } = this.props;

        const userNameForSurvey = twilioUserName ? twilioUserName : userDetails && userDetails.userName ? userDetails.userName : null;

        //Adding target key param in survey to handle our css.        
        const url = this.surveyId && (csnId || externalEventId) && userNameForSurvey ?
            surveyUrl + "ui/TakeVideoVisitSurvey/" + this.surveyId + "?UserId=" + userNameForSurvey + "&externalEventId=" + (externalEventId ? externalEventId : csnId) + "&platform=web" + (isFromNonLogin ? "&SkipThankYou=true" : "") : "";
        const { isSurveyCompleted, showNonLoginVideoVisitComplete} = this.state;

        const iframeResizerOptions = { checkOrigin: false, scrolling: true, heightCalculationMethod: 'bodyScroll', warningTimeout: 10000 };
        const iframeResizerStyle = this.props.style || { width: '100%' };
        //debugger;
        const formID = this.props.id ? this.props.id : "VideoVisitSurvey";
        //debugger;
        return (
            <React.Fragment>
                {url && !isSurveyCompleted && !showNonLoginVideoVisitComplete &&
                    <div className="mychartDataTile wellnessAssessmentTile">
                        <React.Fragment >
                            <ReactIframeResizer ref="thisFrame" key={reloadKey} id={formID} title="Video Visit Survey" iframeResizerOptions={iframeResizerOptions} src={url} style={iframeResizerStyle} />
                        </React.Fragment>
                    </div>
                }
                {showNonLoginVideoVisitComplete &&
                    <VideoVisitComplete isFromNonLogin={isFromNonLogin} />
                }
            </React.Fragment>
        );             
        
    }
}

const mapStateToProps = (state) => {
 
    return {
        userName: state.domain.un,
        userDetails: state.sso.userDetails,
        loginStatus: state.domain.ls,        
        serverData: state.session.serverData,
        token: state.domain.t,
        reloadKey: state.session.reloadKey,
        empId: state.domain.ei,        
        isEmployee: state.domain.ie,
        surveyUrl: state.session.serverData && state.session.serverData.surveyUrl,
        shareLinkSurveyId: state.session.serverData ? state.session.serverData.shareLinkSurveyId : null
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
       
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VideoVisitSurvey));
